import { useEffect, useState, useRef } from 'react';
import * as pdfjsLib from 'pdfjs-dist';
import { RenderParameters } from 'pdfjs-dist/types/src/display/api';

// Set the worker source for pdf.js
pdfjsLib.GlobalWorkerOptions.workerSrc =
  'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.11.338/pdf.worker.min.js';

const PDFViewer = (props: { pdfUrl: string }) => {
  const { pdfUrl } = props;
  const [pdfDoc, setPdfDoc] = useState<pdfjsLib.PDFDocumentProxy | null>(null);
  const [pages, setPages] = useState<number[]>([]);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // Load the PDF document
    const loadPdf = async () => {
      try {
        const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
        setPdfDoc(pdf);
        const numPages = pdf.numPages;

        const pageList = [];
        for (let i = 1; i <= numPages; i++) {
          pageList.push(i);
        }
        setPages(pageList); // Store page numbers
      } catch (error) {
        console.error('Error loading PDF: ', error);
      }
    };

    loadPdf();
  }, [pdfUrl]);

  // Render each page
  const renderPage = (pageNum: number) => {
    if (!pdfDoc) return null;

    pdfDoc.getPage(pageNum).then(page => {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const viewport = page.getViewport({ scale: 1.5 }); // Adjust scale for better quality

      // Set the canvas size
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      // Render the page into the canvas
      const renderContext = {
        canvasContext: context,
        viewport,
      } as RenderParameters;
      page.render(renderContext);

      // Append the canvas to the container
      if (containerRef?.current) containerRef?.current?.appendChild(canvas)!;
    });
  };

  // Render all pages
  useEffect(() => {
    if (pdfDoc) {
      pages.forEach(pageNum => {
        renderPage(pageNum);
      });
    }
  }, [pdfDoc, pages]); // dont update dependency

  return (
    <div ref={containerRef} className="pdf-container">
      {!pdfDoc && <div>Loading...</div>}
    </div>
  );
};

export default PDFViewer;
